import { rainbowTextRevealAnimation } from '#app/components/ContraMagic/animations.js';
import { EditableHeadline as UnstyledEditableHeadline } from '#app/components/EditableHeadline/EditableHeadline.js';
import { FormField } from '#app/components/FormField/FormField.js';
import { Text } from '#app/components/Primitives/Text.js';
import { css, styled } from 'styled-components';

const headlineStyles = () => {
  return css`
    ${({ theme }) => css`
      font-size: 19px;
      font-weight: 600;
      line-height: 1.75;
      word-break: break-word;

      ${theme.mediaQueries.lg} {
        font-size: ${theme.textStyles.fourthLevelHeadline.fontSize};
        font-weight: ${theme.textStyles.fourthLevelHeadline.fontWeight};
        letter-spacing: ${theme.textStyles.fourthLevelHeadline.letterSpacing};
        text-align: left;
      }

      ${theme.mediaQueries.xl} {
        font-size: ${theme.textStyles.thirdLevelHeadline.fontSize};
        font-weight: ${theme.textStyles.thirdLevelHeadline.fontWeight};
        letter-spacing: ${theme.textStyles.thirdLevelHeadline.letterSpacing};
        line-height: ${theme.textStyles.thirdLevelHeadline.lineHeight};
      }
    `}
  `;
};

export const ProfileTitle = styled(Text).attrs({ as: 'h2' })`
  ${headlineStyles}
`;

export const ProfileTitleContainer = styled.div`
  ${({ theme }) => css`
    padding: 24px 0;

    & > button {
      justify-content: flex-start;
    }

    ${theme.mediaQueries.lg} {
      border-top: none;
      padding: unset;
    }
  `}
`;

const EditableHeadline = styled(UnstyledEditableHeadline)`
  ${({ theme }) => css`
    ${headlineStyles}
    text-align: left;
    border-bottom: 1px solid ${theme.colorsV2.black};
    margin-top: 0;
    letter-spacing: normal;
  `}
`;

export const EditableTextCharacterLimit = styled(FormField.Help)`
  ${({ theme }) => css`
    flex-grow: 1;
    text-align: right;

    ${theme.mediaQueries.lg} {
      display: block;
      transition: opacity 250ms ease;
    }
  `}
`;

export const EditableGroup = styled(FormField)`
  ${({ hasError, theme }) => css`
    position: relative;
    margin-bottom: 0;
    padding: 0 0 8px;
    border-bottom: 1px solid ${hasError ? theme.colorsV2.red50 : 'transparent'};
  `}
`;

export const BottomLabels = styled.div`
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ErrorMessage = styled.div`
  ${({ theme }) => css`
    margin-top: 4px;
    padding-left: 16px;
    padding-right: 16px;

    color: ${theme.colorsV2.red50};
    font-size: 12px;
  `}
`;

export const StyledProfileTitle = styled(ProfileTitle)<{
  startRevealHeadlineAnimation?: boolean;
}>`
  ${({ startRevealHeadlineAnimation = false }) => css`
    ${startRevealHeadlineAnimation
      ? css`
          animation: ${rainbowTextRevealAnimation} 3s ease-in-out;
        `
      : undefined}
  `}
`;
export const StyledEditableHeadline = styled(EditableHeadline)<{
  startRevealHeadlineAnimation?: boolean;
}>`
  ${({ startRevealHeadlineAnimation = false }) => css`
    ${startRevealHeadlineAnimation
      ? css`
          animation: ${rainbowTextRevealAnimation} 3s ease-in-out;
        `
      : undefined}
  `}
`;
